import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
    username: '',
}
const mutations = {
    setUser(state, name) {
        state.username = name
    },
}
export default new Vuex.Store({
    state,
    mutations,
})

// 使用的时候，注意版本，vue2 对应vuex3, vue3 对应vuex4

